const Config = { 
    apiPath : "/api/" // !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://127.0.0.1:5000/api/" : "https://kektrophies.co.uk/api/"
}

export default Config;